import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { Box, Button, Typography, IconButton } from "@mui/material";

import { LogoIcon } from "../../assets/icons/MUI/HomeIcons";
import { colors } from "../../theme/palette";
import { GlobeIcon } from "../../assets/icons/MUI/LayoutIcons";
import httpClient from "../../api/axios";
import APP_ROUTES from "../../routers/routeConstants";

const HomeNav = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [currentLang, setCurrentLang] = useState<string>("en");

  const toggleLanguage = () => setCurrentLang((prevLang) => (prevLang === "en" ? "ar" : "en"));

  const myQueryClient = useQueryClient();

  useEffect(() => {
    document.documentElement.dir = currentLang === "ar" ? "rtl" : "ltr";
    i18n.changeLanguage(currentLang);

    httpClient.interceptors.request.use((config) => {
      if (config.headers) config.headers["accept-language"] = currentLang;
      return config;
    });

    myQueryClient.invalidateQueries();
  }, [currentLang]);

  return (
    <Box
      component="nav"
      sx={{
        width: "100%",
        background: "rgba(0, 0, 0, 0.50)",
        position: "absolute",
      }}
    >
      <Box
        sx={{
          height: "60px",
          width: "95%",
          maxWidth: "1240px",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <LogoIcon />
        <Box
          sx={{
            display: "flex",
            gap: "9px",
            alignItems: "center",
          }}
        >
          <IconButton onClick={toggleLanguage} sx={{ position: "relative" }}>
            <Typography
              variant="body10Bold"
              sx={{
                position: "absolute",
                top: "2px",
                right: "0",
                backgroundColor: colors.Green100,
                padding: "2px",
                borderRadius: "50%",
                color: colors.White,
              }}
            >
              {currentLanguage === "ar" ? "EN" : "AR"}
            </Typography>
            <GlobeIcon />
          </IconButton>
          <Button
            onClick={() => navigate(APP_ROUTES.LOGIN)}
            sx={{
              textWrap: "nowrap",
              background: "#FFF !important",
              border: "none",
              borderRadius: "32px",
              padding: {
                xs: "7px 20px",
                lg: "7px 35px",
              },
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "20px",
              color: "var(--Green---100, #008B07) !important",
            }}
          >
            {t("pages.home.signIn")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default HomeNav;
